import * as React from 'react'
import { Backdrop, CircularProgress, Container, styled } from '@mui/material'
import { Typography as MIUTypography } from '@mui/material'
import PropTypes from 'prop-types'
import LinearProgress from '@mui/material/LinearProgress'
import Box from '@mui/material/Box'

const LoadingContainer = styled(Container)(
  () => `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
  `
)

const CircularProgressLoading = styled(CircularProgress)(
  () => `
    margin-right: 1em;
    color: white;
  `
)

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1.4em',
  fontWeight: 700,
  color: '#fff',
  paddingBottom: 6,
  paddingTop: 6,
}))

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  )
}

const LoaderContainer = ({ conditions, children }) => {
  const [progress, setProgress] = React.useState(8)
  const [countMsj, setCountMjs] = React.useState(0)

  const msj = ['Procesando solicitud...', 'Generando registros de árboles...']
  if (progress >= 100 && countMsj < 1) setCountMjs(countMsj + 1)

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prevProgress => (prevProgress >= 100 ? 10 : prevProgress + 2))
    }, 800)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <>
      {children}
      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={conditions.some(Boolean)}>
        <LoadingContainer>
          {countMsj === 0 ? (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <LinearProgressWithLabel value={progress} />
              <Typography>{msj[countMsj]}</Typography>
            </Box>
          ) : (
            <Box
              sx={{
                display: countMsj > 0 ? 'flex' : 'none',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
              }}>
              <Box>
                <CircularProgressLoading />
              </Box>
              <Typography>{msj[countMsj]}</Typography>
            </Box>
          )}
        </LoadingContainer>
      </Backdrop>
    </>
  )
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
}

export default LoaderContainer
